// extracted by mini-css-extract-plugin
export default {"container":"SingleChoice_container__ROalt","label":"SingleChoice_label__XtHr3","radioGroup":"SingleChoice_radioGroup__bTi0S"};